import {Module} from "vuex"
import {RooteState} from "@/store/index";

export interface NavigationState{
  openSideBarNames: string[]
}

export const navigation: Module<NavigationState, RooteState> = {
  namespaced: true,
  state: () => ({
    openSideBarNames: []
  }),
  mutations: {
    setOpenSideBarNames(state, name){
      if (state.openSideBarNames.includes(name)) {
        state.openSideBarNames = state.openSideBarNames.filter((sidebar) => sidebar !== name)
      } else {
        state.openSideBarNames = state.openSideBarNames.concat(name)
      }
    }
  },
}